var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurringSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rotate_left-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEEC-Landingpages",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Creators",
    transform: "translate(-197.000000, -1829.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 1402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate_left-24px",
    transform: "translate(167.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56,7.98 C6.1,7.52 5.31,7.6 5,8.17 C4.72,8.68 4.5,9.2 4.33,9.75 C4.14,10.38 4.64,11 5.29,11 L5.3,11 C5.73,11 6.12,10.72 6.24,10.3 C6.36,9.9 6.52,9.51 6.72,9.13 C6.94,8.76 6.87,8.29 6.56,7.98 L6.56,7.98 Z M5.31,13 L5.29,13 C4.64,13 4.14,13.62 4.33,14.25 C4.49,14.79 4.71,15.32 4.99,15.83 C5.3,16.4 6.1,16.49 6.56,16.03 C6.86,15.72 6.94,15.26 6.73,14.88 C6.53,14.51 6.37,14.12 6.25,13.72 C6.13,13.28 5.74,13 5.31,13 L5.31,13 Z M8.16,19.02 C8.67,19.3 9.2,19.52 9.75,19.68 C10.37,19.86 10.99,19.36 10.99,18.72 L10.99,18.69 C10.99,18.26 10.71,17.87 10.29,17.75 C9.89,17.63 9.51,17.47 9.14,17.27 C8.76,17.06 8.28,17.13 7.98,17.44 L7.95,17.47 C7.5,17.92 7.59,18.71 8.16,19.02 Z M13,4.07 L13,3.41 C13,2.52 11.92,2.07 11.29,2.7 L9.17,4.83 C8.77,5.23 8.77,5.87 9.17,6.26 L11.3,8.34 C11.93,8.96 13,8.51 13,7.62 L13,6.09 C15.84,6.57 18,9.03 18,12 C18,14.73 16.18,17.02 13.68,17.75 C13.27,17.87 13,18.26 13,18.69 L13,18.71 C13,19.36 13.61,19.85 14.23,19.67 C17.57,18.71 20,15.64 20,12 C20,7.92 16.95,4.56 13,4.07 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringSvg);
export default __webpack_public_path__ + "static/media/RecurringSvg.be7a25b33d44aed3d8cca4c9c78bff0e.svg";
export { ForwardRef as ReactComponent };